import { ForwardedRef, forwardRef } from 'react';
import { clsx } from '@team/clsx';
import { Misc } from '@team/misc';
import { RootComponent } from '../../../root-component';
import { Props } from '../../types';
import { useState } from '../../hooks/state';
import css from './style.module.css';

/**
 * Интерактивный элемент
 */
export const Entry = forwardRef(function Interactive<T>(
  {
    baseClassName,
    children,
    hasHover,
    shouldForceHovered,
    hoverClassName,
    hasActive,
    shouldForceActivated,
    activeClassName,
    activeEffectDelay,
    onPointerEnter,
    onPointerLeave,
    onPointerDown,
    onPointerCancel,
    onPointerUp,
    ...props
  }: Props<T>,
  forwardedRef: ForwardedRef<T>
) {
  const state = useState({
    hasHover,
    shouldForceHovered,
    hoverClassName,
    hasActive,
    shouldForceActivated,
    activeClassName,
    activeEffectDelay,
  });

  const handlers = Misc.mergeCalls(state.handlers, {
    onPointerEnter,
    onPointerLeave,
    onPointerDown,
    onPointerCancel,
    onPointerUp,
  });

  return (
    <RootComponent
      {...props}
      baseClassName={clsx(baseClassName, css.root, state.className)}
      {...handlers}
      ref={forwardedRef}
    >
      {children}
    </RootComponent>
  );
});
